<template>
  <section>
    <error-display-component :serverErrors="serverErrors" :serverErrorMessage="serverErrorMessage" id="error-container"></error-display-component>
    <div v-show="isValidToken && !isLoading" class="hero">
      <div class="hero-body container container box has-background-white-bis">
        <div class="steps" id="stepsDemo">
          <div class="step-item is-active is-success">
            <div class="step-marker">1</div>
            <div class="step-details">
              <p class="step-title" style="text-decoration: none;" v-if="mobile">
                <i title="Supplier" class="fal fa-truck-loading fa-lg"></i>
              </p>
              <p class="step-title" v-else>SUPPLIER</p>
            </div>
          </div>
          <div class="step-item">
            <div class="step-marker">2</div>
            <div class="step-details">
              <p class="step-title" style="text-decoration: none;" v-if="mobile">
                <i title="Address" class="fal fa-building fa-lg"></i>
              </p>
              <p class="step-title" v-else>ADDRESS</p>
            </div>
          </div>
          <div class="step-item">
            <div class="step-marker">3</div>
            <div class="step-details">
              <p class="step-title" style="text-decoration: none;" v-if="mobile">
                <i title="Bank Details" class="fal fa-university fa-lg"></i>
              </p>
              <p class="step-title" v-else>BANK DETAILS</p>
            </div>
          </div>
          <div class="step-item">
            <div class="step-marker">4</div>
            <div class="step-details">
              <p class="step-title" style="text-decoration: none;" v-if="mobile">
                <i title="Contacts" class="fal fa-user-friends fa-lg"></i>
              </p>
              <p class="step-title" v-else>CONTACTS</p>
            </div>
          </div>
          <div class="step-item">
            <div class="step-marker">5</div>
            <div class="step-details">
              <p class="step-title" style="text-decoration: none;" v-if="mobile">
                <i title="Documents" class="fal fa-folder-open fa-lg"></i>
              </p>
              <p class="step-title" v-else>DOCUMENTS</p>
            </div>
          </div>
          <div class="step-item">
            <div class="step-marker">6</div>
            <div class="step-details">
              <p class="step-title" style="text-decoration: none;" v-if="mobile">
                <i title="Terms" class="fal fa-file-signature fa-lg"></i>
              </p>
              <p class="step-title" v-else>TERMS</p>
            </div>
          </div>
          <div class="steps-content">
            <div class="step-content">
              <div class="credit-app has-background-grey-dark has-text-white">
                Please confirm your information
              </div>
              <form class="has-text-centered is-active" data-vv-scope="step1">
                <section class="has-text-left">
                  <div class="columns is-multiline">
                    <div class="column is-12">
                      <div class="field">
                        <label class="label">Name<b-icon pack="fas" icon="star" class="fa-ss"></b-icon></label>
                          <div class="control">
                            <input name="name" v-validate="{'required': true, 'max': 250}" :class="{'input': true, 'is-danger': errors.has('step1.name') }" data-vv-scope="step1" data-vv-as="name" type="text" placeholder="Name" v-model="supplier.name" :disabled="true">
                            <span v-show="errors.has('step1.name')" class="help is-danger">
                              <i v-show="errors.has('step1.name')" class="fas fa-exclamation-triangle"></i>{{ errors.first('step1.name') }}
                            </span>
                          </div>
                      </div>
                    </div>
                    <div class="column is-12">
                      <label class="form-info">If you would like to change your company name, please contact your sales person.</label>
                    </div>
                    <div class="column is-12">
                      <div class="field">
                        <label class="label">Office no.<b-icon pack="fas" icon="star" class="fa-ss"></b-icon></label>
                        <div class="control has-icons-right">
                          <input name="office" v-validate="{'required': true, 'min': 16, 'max': 16}" :class="{'input': true, 'is-danger': errors.has('step1.office') }" data-vv-scope="step1" data-vv-as="office phone" type="tel" placeholder="+1(999)-999-9999" v-mask="'+1(###)-###-####'" v-model="supplier.office">
                          <span v-show="errors.has('step1.office')" class="help is-danger">
                            <i v-show="errors.has('step1.office')" class="fas fa-exclamation-triangle"></i>{{ errors.first('step1.office') }}
                          </span>
                          <span class="icon is-small is-right">
                            <i class="fal fa-phone-volume default-blue"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="column is-12">
                      <div class="field">
                        <label class="label">Fax</label>
                        <div class="control has-icons-right">
                          <input name="fax" v-validate="{'min': 16, 'max': 16}" :class="{'input':true, 'is-danger': errors.has('step1.fax') }" data-vv-scope="step1" data-vv-as="fax" type="tel" placeholder="+1(999)-999-9999" v-mask="'+1(###)-###-####'" v-model="supplier.fax">
                          <span v-show="errors.has('step1.fax')" class="help is-danger">
                            <i v-show="errors.has('step1.fax')" class="fas fa-exclamation-triangle"></i>{{ errors.first('step1.fax') }}
                          </span>
                          <span class="icon is-small is-right">
                            <i class="fal fa-fax default-blue"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </form>
            </div>
            <form class="step-content has-text-centered" data-vv-scope="step2">
              <section class="has-text-left">
                <div class="credit-app has-background-grey-dark has-text-white">
                  <p>Confirm your organization address details.</p>
                </div>
                <div v-for="(address, index) in addresses" :key="address.id">
                  <address-capture v-model="addresses[index]" :addressIndex="index" :useValidator="thisValidator"  :supplierVerification="true" scope="step2" :required="true"></address-capture>
                  <br/>
                </div>
              </section>
            </form>
            <form class="step-content has-text-centered" data-vv-scope="step3">
              <section class="has-text-left">
                <div class="credit-app has-background-grey-dark has-text-white">
                  <p>Confirm your organization bank details.</p>
                </div>
                <div class="columns is-multiline">
                  <div class="column is-12">
                    <div class="field">
                      <label class="label">Bank Name<b-icon pack="fas" icon="star" class="fa-ss"></b-icon></label>
                      <div class="control">
                        <multiselect
                          :multiple="false"
                          id="bank"
                          name="bank"
                          v-validate="{'required': isBankDetailsRequired}"
                          :class="errors.has('step3.bank') ? 'is-danger': ''"
                          data-vv-scope="step3"
                          data-vv-as="bank"
                          placeholder="Select Bank"
                          label="text"
                          track-by="value"
                          :options="bankOptions"
                          :searchable="false"
                          v-model="selectedBank">
                        </multiselect>
                      </div>
                      <span v-show="errors.has('step3.bank')" class="help is-danger">
                        <i v-show="errors.has('step3.bank')" class="fas fa-exclamation-triangle"></i>{{ errors.first('step3.bank') }}
                      </span>
                    </div>
                  </div>
                  <div class="column is-6">
                    <div class="field">
                      <label class="label">Branch Name</label>
                      <div class="control">
                        <input name="branchName" :class="{'input': true }" type="text" v-model="supplier.branchName" placeholder="Branch">
                      </div>
                    </div>
                  </div>
                  <div class="column is-6">
                    <div class="field">
                      <label class="label">Branch Number</label>
                      <div class="control">
                        <input name="branchNo" :class="{'input': true }" type="text" v-model="supplier.branchNo" placeholder="Branch Number">
                      </div>
                    </div>
                  </div>
                  <div class="column is-12">
                    <div class="field">
                      <label class="label">Account Holder<b-icon v-if="isBankDetailsRequired" pack="fas" icon="star" class="fa-ss"></b-icon></label>
                      <div class="control">
                        <input name="accountHolder" v-validate="{'required': isBankDetailsRequired}" :class="{'input': true, 'is-danger': errors.has('step3.accountHolder') }" data-vv-scope="step3" data-vv-as="account holder" type="text" v-model="supplier.accountHolder" placeholder="Account Holder Name">
                        <span v-show="errors.has('step3.accountHolder')" class="help is-danger">
                          <i v-show="errors.has('step3.accountHolder')" class="fas fa-exclamation-triangle"></i>{{ errors.first('step3.accountHolder') }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="column is-12">
                    <div class="field">
                      <label class="label">Account Number<b-icon v-if="isBankDetailsRequired" pack="fas" icon="star" class="fa-ss"></b-icon></label>
                      <div class="control">
                        <input name="accountNo" v-validate="{'required': isBankDetailsRequired}" :class="{'input': true, 'is-danger': errors.has('step3.accountNo') }" data-vv-scope="step3" data-vv-as="account no" type="text" v-model="supplier.accountNo" placeholder="Account Number">
                        <span v-show="errors.has('step3.accountNo')" class="help is-danger">
                          <i v-show="errors.has('step3.accountNo')" class="fas fa-exclamation-triangle"></i>{{ errors.first('step3.accountNo') }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="column is-6">
                    <button-list-selector
                      validateAs="bank account type"
                      label="Account Type"
                      :required="isBankDetailsRequired"
                      :availableValues="definedTypes.bankAccountTypes"
                      scope="step3"
                      v-model="selectedAccountType"
                      placeholder="Select Account Type">
                    </button-list-selector>
                  </div>
                  <div class="column is-6">
                    <div class="field">
                      <label class="label">Swift Number<b-icon v-if="isBankDetailsRequired" pack="fas" icon="star" class="fa-ss"></b-icon></label>
                      <div class="control">
                        <input name="swiftNo" v-validate="{'required': isBankDetailsRequired}" :class="{'input': true, 'is-danger': errors.has('step3.swiftNo') }" data-vv-scope="step3" data-vv-as="swift number" type="text" v-model="supplier.swiftNo" placeholder="Swift Number - AAAABB11222">
                        <span v-show="errors.has('step3.swiftNo')" class="help is-danger">
                          <i v-show="errors.has('step3.swiftNo')" class="fas fa-exclamation-triangle"></i>{{ errors.first('step3.swiftNo') }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </form>
            <form class="step-content has-text-centered" data-vv-scope="step4">
              <section class="has-text-left">
                <div class="credit-app has-background-grey-dark has-text-white">
                  <p>Confirm your primary contact details.</p>
                </div>
                <h3 class="has-text-info">Additional records can be created</h3>
                <div v-for="(contact, index) in contacts" :key="contact.id">
                  <contact-capture v-model="contacts[index]" scope="step4" :index="index" @on-contact-remove="removeContact(contact)" @contactBuyerChanged="onNewContactBuyer" @contactSellerChanged="onNewContactSeller" :isRequired="true" @autoSelectPrimaryContact="onAutoSelectPrimaryContact"></contact-capture>
                  <br/>
                </div>
                <div class="inner-add-remove-button">
                  <b-button icon-left="fa fa-lg fa-plus-circle" type="is-info" inverted @click="addContact()">Add Contact</b-button>
                </div>
              </section>
            </form>
            <form class="step-content has-text-centered" data-vv-scope="step5">
              <section class="has-text-left">
                <div class="credit-app has-background-grey-dark has-text-white">
                  <p>Please provide your dealer license and sales tax certificate.</p>
                </div>
                <div class="is-full">
                  <div class="field is-full">
                    <file-selector v-model="dealerFiles" label="Dealer's License" :multiple="false" :token="this.token" scope="step3" destinationUrl="/upload/supplierReceive"></file-selector>
                  </div>
                  <div class="field is-full">
                    <file-selector v-model="salesTaxFiles" label="Sales Tax Certificate" :multiple="false" :token="this.token" scope="step3" destinationUrl="/upload/supplierReceive"></file-selector>
                  </div>
                </div>
              </section>
            </form>
            <div class="step-content has-text-centered">
              <div v-observe-visibility="visibilityChanged">
                <div class="credit-app has-background-grey-dark has-text-white">
                  Please review and accept the terms and conditions
                </div>
                <div class="field">
                  <generic-terms-control v-model="supplier.isTermsAccepted"></generic-terms-control>
                </div>
              </div>
            </div>
          </div>
          <div class="steps-actions">
            <div class="steps-action">
              <b-button icon-left="chevron-left" data-nav="previous" class="is-light" :disabled="hasSaved">Previous</b-button>
            </div>
            <div class="steps-action">
              <b-button icon-right="chevron-right" data-nav="next" class="next-step"  @click='nextStepCheck' :disabled="hasSaved">Next</b-button>
            </div>
            <div class="steps-action" v-if="termsVisible && canSave">
              <a class="button next-step" @click="onSave()" :disabled="hasSaved">Submit</a>
            </div>
          </div>
          </div>
      </div>
    </div>
  </section>
  </template>
<script>
import bulmaSteps from 'bulma-steps/dist/js/bulma-steps'
import supplierService from '@/services/supplierService'
import addressCapture from '@/components/generic/AddressCapture'
import validateBeforeSubmitMixin from '@/mixins/generic/validateBeforeSubmit'
import ErrorDisplayComponent from '@/components/generic/ErrorDisplayComponent'
import FileSelector from '@/components/generic/FileSelector'
import utilitiesMixin from '@/mixins/generic/utilities'
import ContactCapture from '@/components/generic/ContactCapture'
import ButtonListSelector from '@/components/generic/ButtonListSelector'
import supplierMixin from '@/mixins/supplier/index'
import customerService from '@/services/customerService'
import { mapActions, createNamespacedHelpers } from 'vuex'
import GenericTermsControl from '@/components/generic/GenericTermsControl'

const mapConfigGetters = createNamespacedHelpers('config').mapGetters

export default {
  name: 'SupplierIdentityVerification',
  inject: {
    $validator: '$validator'
  },
  props: {
    token: {
      type: String,
      default: ''
    }
  },
  components: {
    'address-capture': addressCapture,
    'error-display-component': ErrorDisplayComponent,
    'file-selector': FileSelector,
    'contact-capture': ContactCapture,
    'button-list-selector': ButtonListSelector,
    'generic-terms-control': GenericTermsControl
  },
  mixins: [validateBeforeSubmitMixin, utilitiesMixin, supplierMixin],
  data () {
    return {
      mobile: window.innerWidth <= 700,
      isLoading: false,
      itemsHidden: false,
      addresses: [],
      banks: [],
      currentStep: 0,
      termsVisible: false,
      isSaving: false,
      todayDate: new Date(),
      allStates: [],
      canSave: false,
      serverErrors: [],
      serverErrorMessage: '',
      isValidToken: false,
      preventClick: false,
      loadingBaseData: false,
      dealerId: 0,
      hasSaved: false,
      dealerFiles: [],
      salesTaxFiles: [],
      supplierEmailValid: false,
      reg: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      currentUrl: '',
      selectedBank: null,
      contacts: [],
      selectedAccountType: null,
      supplier: {
        accountHolder: '',
        accountNo: '',
        accountType: '',
        address1: '',
        address2: '',
        address3: '',
        address4: '',
        allowPaymentWithoutTitle: false,
        approved: false,
        bankId: 0,
        bankName: '',
        branchName: '',
        branchNo: '',
        city: '',
        contacts: [],
        country: '',
        createdAt: null,
        dealerId: 0,
        dealerLicenceExpiration: null,
        dealerLicenceFileLocation: '',
        dealerLicenceFileName: '',
        dealerLicenceImageName: '',
        dealerLicenceUniqueId: null,
        dealerLicenceUploadName: null,
        defaultPaymentMethod: '',
        email: '',
        fax: '',
        fullAddress: '',
        gpsAddress: '',
        id: 0,
        isBlocked: false,
        isContinueLater: false,
        isPartial: false,
        isTermsAccepted: false,
        managedBy: 0,
        managedByName: '',
        modifiedAt: null,
        name: '',
        office: '',
        postalCode: '',
        primaryContact: '',
        primaryContactMobile: '',
        salesTaxCertificateExpiration: null,
        salesTaxCertificateFileLocation: '',
        salesTaxCertificateFileName: '',
        salesTaxCertificateImageName: '',
        salesTaxCertificateUniqueId: null,
        salesTaxCertificateUploadName: null,
        state: '',
        status: '',
        subscriberId: 0,
        subscriberName: '',
        swiftNo: '',
        termsAcceptedAt: null,
        trusted: false,
        url: null,
        userId: 0,
        w9Expiration: null,
        w9FileLocation: null,
        w9FileName: null,
        w9ImageName: null,
        w9UniqueId: null,
        w9UploadName: null
      }
    }
  },
  computed: {
    ...mapConfigGetters(['definedTypes']),
    isTermsAccepted: function () {
      return this.supplier.isTermsAccepted
    },
    supplierEmail: function () {
      return this.supplier.email
    },
    bankOptions: function () {
      return this.banks.map(d => ({ text: d.name, value: d.id }))
    },
    thisValidator: function () {
      return (this && this.$validator) ? this.$validator : null
    },
    isBankDetailsRequired: function () {
      return this.dealerId !== 10010
    }
  },
  methods: {
    ...mapActions(['updateReturnUrl', 'updateIsContinueLater']),
    fetchSupplierApplication: function (currentToken) {
      this.serverErrorMessage = ''
      this.loadingBaseData = true
      this.isLoading = true
      supplierService.getSupplierIdentityVerification(currentToken).then(response => {
        this.supplier = {
          ...response.data
        }
        this.dealerId = this.supplier.dealerId
        if (!this.dealerId || this.dealerId === 0) {
          this.serverErrorMessage = 'Could not retrieve supplier information with code : ' + currentToken
        } else {
          this.isValidToken = true
          this.isLoading = false
          this.initInputValues()
        }
      // eslint-disable-next-line handle-callback-err
      }).catch((error) => {
        this.isLoading = false
        this.serverErrorMessage = 'Could not retrieve supplier information with code: ' + currentToken
        this.isValidToken = false
      })
    },
    initInputValues () {
      if (this.supplier != null) {
        this.addresses = []
        var addressData = {
          id: this.$uuid.v4(),
          address1: this.supplier.address1,
          address2: this.supplier.address2,
          address3: this.supplier.address3,
          address4: this.supplier.address4,
          city: this.supplier.city,
          country: this.supplier.country,
          postalCode: this.supplier.postalCode,
          state: this.supplier.state,
          gpsAddress: this.supplier.gpsAddress,
          ownershipType: null,
          years: 0,
          months: 0,
          rate: 0
        }
        this.addresses.push(addressData)
        this.supplier.contacts.forEach(function (contact) {
          let sortOrder = 3
          if (contact.isPrimary) {
            sortOrder = 0
          } else if (contact.status === 'Active') {
            sortOrder = 1
          }
          var config = {
            sectionId: this.contacts.length + 100
          }
          contact.config = config
          contact.selectedReceivesBuyersOrder = this.definedTypes.fillTypes.options.find((x) => x.id === (contact.receivesBuyersOrder ? 0 : 1))
          contact.selectedReceivesSellersOrder = this.definedTypes.fillTypes.options.find((x) => x.id === (contact.receivesSellersOrder ? 0 : 1))
          contact.selectedReceivesPaymentAndTitle = this.definedTypes.fillTypes.options.find((x) => x.id === (contact.receivesPaymentAndTitle ? 0 : 1))
          contact.selectedIsPrimary = this.definedTypes.fillTypes.options.find((x) => x.id === (contact.isPrimary ? 0 : 1))
          contact.selectedActiveStatus = this.definedTypes.fillTypes.options.find((x) => x.id === (contact.status === 'Active' ? 0 : 1))
          contact.sortOrder = sortOrder
          this.contacts.push(contact)
        }, this)

        if (this.supplier.dealerLicenceFileLocation) {
          var dealerLicenceFile = {
            loaded: true,
            imageData: this.supplier.dealerLicenceFileLocation,
            fileName: this.supplier.dealerLicenceImageName,
            fileLocation: this.supplier.dealerLicenceFileLocation,
            name: this.supplier.dealerLicenceImageName,
            fileType: this.getFileType(this.supplier.dealerLicenceFileLocation)
          }

          this.dealerFiles.push(dealerLicenceFile)
        }
        if (this.supplier.salesTaxCertificateFileLocation) {
          var salesTaxFile = {
            loaded: true,
            imageData: this.supplier.salesTaxCertificateFileLocation,
            fileName: this.supplier.salesTaxCertificateImageName,
            fileLocation: this.supplier.salesTaxCertificateFileLocation,
            name: this.supplier.salesTaxCertificateImageName,
            fileType: this.getFileType(this.supplier.salesTaxCertificateFileLocation)
          }

          this.salesTaxFiles.push(salesTaxFile)
        }
        if (this.addresses.length === 0) {
          this.addAddress({})
        }
        if (this.contacts.length === 0) {
          this.addContact(true)
        }
        if (this.supplier && this.supplier.bankId !== 0) {
          this.selectedBank = this.bankOptions.find((x) => x.value === this.supplier.bankId)
        }
        this.selectedAccountType = this.supplier.accountType ? this.definedTypes.bankAccountTypes.find((x) => (x.name === this.supplier.accountType)) : this.definedTypes.bankAccountTypes.find((x) => x.name === 'Check')
      }
    },
    visibilityChanged (isVisible, entry) {
      this.termsVisible = isVisible
    },
    onSave: function () {
      this.supplier.isContinueLater = false
      this.save()
    },
    evaluateRequiredTermsVisibility () {
      this.evaluateValidToSubmit()
    },
    evaluateValidToSubmit () {
      this.canSave = this.supplier.isTermsAccepted
    },
    async nextStepCheck (e) {
      const stepScopes = ['step1', 'step2', 'step3', 'step4', 'step5']
      const currentStep = stepScopes[this.currentStep]
      var isValid = await this.$validator.validateAll(currentStep)
      this.preventClick = !isValid
    },
    onComplete () {
      if (this.supplier.isContinueLater) {
        this.$router.push({ name: 'SupplierIdentityVerificationContinueLater' })
      } else {
        this.$router.push({ name: 'SupplierIdentityVerificationComplete' })
      }
    },
    resetSupplier () {
      this.supplier = {
        accountHolder: '',
        accountNo: '',
        accountType: '',
        address1: '',
        address2: '',
        address3: '',
        address4: '',
        allowPaymentWithoutTitle: false,
        approved: false,
        bankId: 0,
        bankName: '',
        branchName: '',
        branchNo: '',
        city: '',
        contacts: [],
        country: '',
        createdAt: null,
        dealerId: 0,
        dealerLicenceExpiration: null,
        dealerLicenceFileLocation: '',
        dealerLicenceFileName: '',
        dealerLicenceImageName: '',
        dealerLicenceUniqueId: null,
        dealerLicenceUploadName: null,
        defaultPaymentMethod: '',
        email: '',
        fax: '',
        fullAddress: '',
        gpsAddress: '',
        id: 0,
        isBlocked: false,
        isContinueLater: false,
        isPartial: false,
        isTermsAccepted: false,
        managedBy: 0,
        managedByName: '',
        modifiedAt: null,
        name: '',
        office: '',
        postalCode: '',
        primaryContact: '',
        primaryContactMobile: '',
        salesTaxCertificateExpiration: null,
        salesTaxCertificateFileLocation: '',
        salesTaxCertificateFileName: '',
        salesTaxCertificateImageName: '',
        salesTaxCertificateUniqueId: null,
        salesTaxCertificateUploadName: null,
        state: '',
        status: '',
        subscriberId: 0,
        subscriberName: '',
        swiftNo: '',
        termsAcceptedAt: null,
        trusted: false,
        url: null,
        userId: 0,
        w9Expiration: null,
        w9FileLocation: null,
        w9FileName: null,
        w9ImageName: null,
        w9UniqueId: null,
        w9UploadName: null
      }
    },
    async saveAndContinueLater () {
      this.supplier.isContinueLater = true
      this.supplier.url = this.currentUrl
      await this.updateReturnUrl(this.currentUrl)
      await this.updateIsContinueLater(true)
      this.save()
    },
    save () {
      var supplierModel = {
        accountHolder: this.supplier.accountHolder,
        accountNo: this.supplier.accountNo,
        accountType: this.selectedAccountType.id,
        bankId: this.selectedBank ? this.selectedBank.value : 0,
        bankName: this.selectedBank ? this.selectedBank.text : '',
        branchName: this.supplier.branchName,
        branchNo: this.supplier.branchNo,
        contacts: [],
        createdAt: this.supplier.createdAt,
        dealerId: this.supplier.dealerId,
        dealerLicenceExpiration: this.supplier.dealerLicenceExpiration,
        email: this.supplier.email,
        fax: this.supplier.fax,
        id: this.supplier.id,
        isContinueLater: this.supplier.isContinueLater,
        isPartial: this.supplier.isPartial,
        isTermsAccepted: this.supplier.isTermsAccepted,
        managedBy: this.supplier.managedBy,
        managedByName: this.supplier.managedByName,
        modifiedAt: this.supplier.modifiedAt,
        name: this.supplier.name,
        office: this.supplier.office,
        salesTaxCertificateExpiration: this.supplier.salesTaxCertificateExpiration,
        status: this.supplier.status,
        subscriberId: this.supplier.subscriberId,
        subscriberName: this.supplier.subscriberName,
        swiftNo: this.supplier.swiftNo,
        termsAcceptedAt: this.supplier.termsAcceptedAt,
        url: this.currentUrl,
        userId: this.supplier.userId,
        w9Expiration: this.supplier.w9Expiration,
        address1: this.addresses[0].address1,
        address2: this.addresses[0].address2,
        address3: this.addresses[0].address3,
        address4: this.addresses[0].address4,
        city: this.addresses[0].city,
        country: this.addresses[0].country,
        postalCode: this.addresses[0].postalCode,
        state: this.addresses[0].state,
        gpsAddress: this.addresses[0].gpsAddress,
        token: this.token
      }
      //
      this.hasSaved = true

      this.saveContact(supplierModel)

      supplierModel.uploadName = this.supplier.uploadName
      supplierModel.uniqueId = this.supplier.uniqueId

      if (this.dealerFiles.length > 0) {
        var dealerFile = this.dealerFiles.filter((y) => !y.id || y.id <= 0).map((x) => {
          return {
            uploadName: x.name,
            uniqueId: x.uniqueId
          }
        })

        supplierModel.dealerLicenceUploadName = dealerFile[0].uploadName
        supplierModel.dealerLicenceUniqueId = dealerFile[0].uniqueId
      } else {
        supplierModel.driversUploadName = ''
        supplierModel.driversUniqueId = ''
      }

      if (this.salesTaxFiles.length > 0) {
        var salesTaxFile = this.salesTaxFiles.filter((y) => !y.id || y.id <= 0).map((x) => {
          return {
            uploadName: x.name,
            uniqueId: x.uniqueId
          }
        })

        supplierModel.salesTaxCertificateUploadName = salesTaxFile[0].uploadName
        supplierModel.salesTaxCertificateUniqueId = salesTaxFile[0].uniqueId
      } else {
        supplierModel.insuranceUploadName = ''
        supplierModel.insuranceUniqueId = ''
      }

      this.isSaving = true
      this.serverErrorMessage = ''
      this.serverErrors = []

      supplierService.identityVerification(supplierModel).then(response => {
        this.isSaving = false
        if (response.errors) {
          this.serverErrors = response.errors
          this.$nextTick(function () {
            var elmnt = document.getElementById('main-page')
            elmnt.scrollTo(0, 0)
          })
          this.hasSaved = false
        } else {
          this.$emit('on-save', response.supplier)
          this.onChangesSaved()
          this.onComplete()
          this.hasSaved = false
        }
      }).catch((error) => {
        this.serverErrorMessage = error.message
        this.isSaving = false
        this.$nextTick(function () {
          var elmnt = document.getElementById('main-page')
          elmnt.scrollTo(0, 0)
        })
        this.hasSaved = false
      })
    },
    fetchAllBanks: function () {
      const that = this
      supplierService.fetchAllBanks().then(response => {
        that.banks = response.results
        that.fetchSupplierApplication(that.token)
      }).catch((error) => {
        this.serverErrorMessage = error.message
      })
    },
    checkRemoveButtonVisibility (dataCollection) {
      if (dataCollection.length > 1) {
        return true
      }
      return false
    },
    fetchAllStates: function () {
      const that = this
      customerService.allStates().then(response => {
        this.allStates = response.results
        that.fetchAllBanks()
      }).catch((error) => {
        this.serverErrorMessage = error.message
      })
    }
  },
  created () {
    this.currentUrl = window.location.href
    this.$emit('is-home', false)
  },
  mounted () {
    bulmaSteps.attach('.steps', {
      beforeNext: id => {
        var beforeNextResult = {}
        if (this.preventClick) {
          beforeNextResult.errors = ['Error occured']
          return beforeNextResult
        } else {
          return beforeNextResult
        }
      },
      beforePrevious: id => {
        this.currentStep = id
      },
      onShow: id => {
        var elmnt = document.getElementById('main-page')
        elmnt.scrollTo(0, 0)
        this.currentStep = id
      }
    })
    this.resetSupplier()
    this.fetchAllStates()
    this.$emit('set-title-one', 'IDENTITY')
    this.$emit('set-title-two', 'VERIFICATION')
  },
  watch: {
    isTermsAccepted () {
      this.evaluateValidToSubmit()
    },
    token: function (newValue, oldValue) {
      this.isValidToken = false
      this.fetchSupplierApplication(this.token)
    },
    supplierEmail () {
      this.supplierEmailValid = this.supplier.email && this.supplier.email.length > 1 && this.reg.test(this.supplier.email)
    }
  }
}

</script>

<style scoped>

</style>
